import React, { createContext, useMemo, useState } from 'react'
import { Outlet, useLocation } from 'react-router-dom'

type PanelContextProps = {
  collapsed: boolean
  setCollapsed: React.Dispatch<React.SetStateAction<boolean>>
  activeMenu: string
}

const PanelContext = createContext<PanelContextProps>({} as PanelContextProps)

export const PanelProvider: React.FC = () => {
  const [ collapsed, setCollapsed ] = useState<boolean>(false)

  const location = useLocation()

  const activeMenu = useMemo(() => {
    console.log('Location pathname:', location.pathname)
    const path = location.pathname
    if (path === '/') return '/home'
    return path
  }, [location])

  console.log('ActiveMenu value:', activeMenu)

  return (
    <PanelContext.Provider
      value={{
        collapsed,
        setCollapsed,
        activeMenu,
      }}
    >
      <Outlet />
    </PanelContext.Provider>

  )
}

export default PanelContext
